import PropTypes from 'prop-types';
import React from 'react';

import Modal from 'components/Modal';
import I18n from 'utils/I18n';
import { CONSENT_LIST_STATUS } from 'utils/Iterable/constants';

const ConsentConfirmationModal = ({ isOpen, closeModal, decision }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      overlayOpacity={0.5}
      portalClassName="ConsentConfirmationModal__portal"
    >
      <div className="ConsentConfirmationModal mx-auto max-w-md rounded-lg bg-white p-8 text-center">
        {decision !== CONSENT_LIST_STATUS.ERROR && (
          <>
            <h2 className="mb-4 text-2xl font-bold text-gray-900">
              {I18n.localize('consentConfirmationModal.title')}
            </h2>
            <p className="mb-6 text-gray-600">
              {I18n.localize(`consentConfirmationModal.${decision}`)}
            </p>
          </>
        )}
        {decision === CONSENT_LIST_STATUS.ERROR && (
          <p className="mb-6 text-gray-600">{I18n.localize('consentConfirmationModal.error')}</p>
        )}
      </div>
    </Modal>
  );
};

ConsentConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  decision: PropTypes.string,
};

ConsentConfirmationModal.defaultProps = {
  decision: CONSENT_LIST_STATUS.ACCEPTED,
};

export default ConsentConfirmationModal;
